<template>
  <div class="most-wrap-bg">
    <div class="ct-large ct-large-carousel">
      <div v-if="isMobile" class="row most-swiper-container most-wrapper">
        <div class="swiper-wrapper">
            <slot name="most-recent"></slot>
            <slot name="most-popular"></slot>
        </div>
      </div>
      <div v-else>
        <div class="row no-gutters">
          <div class="col-12 col-md-6 col-lg-7 col-xl-9">
            <slot name="most-recent"></slot>
          </div>
          <div class="col-12 col-md-6 col-lg-5 col-xl-3">
            <slot name="most-popular"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'

export default {
  name: 'most-wrapper',
  data() {
    return {
      swiper: null,
      width: 0
    }
  },
  computed: {
    isMobile() {
      return this.width <= 766
    }
  },
  mounted() {
    this.swiper = new Swiper('.most-swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 50,
      centeredSlides: true
    })

    window.addEventListener('resize', this.onResize)
    this.onResize()
  },
  methods: {
    onResize() {
      this.swiper.virtual.update()
      this.width = window.innerWidth
    }
  }
}
</script>
